import React, { useState } from 'react';
import { TimeMatrixQuestion } from '../../survey-tools/likert-scales';
import { Checkbox, FormGroup, FormControlLabel, TextField, Typography, Button } from '@mui/material';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog, CustomHourDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function SocialInteraction({ instanceId,nextTask }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [showDialog, setShowDialog] = useState(false);
    const [showHourDialog, setShowHourDialog] = useState(false);

    const socialActivitiesList = [
        "Sleeping",
        "Awake and all by yourself",
        "Interacting with other people online or on the phone",
        "Around other people in the same physical space, but not interacting",
        "Interacting with others face-to-face"
    ];

    const onlineActivitiesList = [
        "Texting or instant/direct messaging someone",
        "Posting on social media",
        "Emailing someone",
        "Video, voice, or group calling"
    ];

    const interactionCategories = {
        spousePartner: "Spouse/partner",
        children: "Children",
        parents: "Parents",
        otherRelatives: "Other relatives",
        closeFriends: "Close friends",
        otherFriends: "Other friends",
        roommates: "Roommates",
        coWorkers: "Co-workers",
        acquaintances: "Acquaintances",
        medicalPersonnel: "Medical personnel (e.g. nurses, doctors, etc..)",
        retailWorkers: "Retail, hospitality, and service workers (e.g. cashiers, servers, etc..)" };

    const socialActivitiesMap = {
    "Sleeping": "sleeping",
    "Awake and all by yourself": "alone",
    "Interacting with other people online or on the phone": "interacting_online",
    "Around other people in the same physical space, but not interacting": "same_space",
    "Interacting with others face-to-face": "interacting_in_person"
};

    const onlineActivitiesMap = {
    "Texting or instant/direct messaging someone": "direct_message",
    "Posting on social media": "social_media_post",
    "Emailing someone": "email",
    "Video, voice, or group calling": "calling"
};

const interactionTypesMap = {
    "Spouse/partner": "partner",
    "Children": "children",
    "Parents": "parents",
    "Other relatives": "other_relatives",
    "Close friends": "close_friends",
    "Other friends": "other_friends",
    "Roommates": "roommates",
    "Co-workers": "coworkers",
    "Acquaintances": "acquaintances",
    "Medical personnel (e.g. nurses, doctors, etc..)": "medical_personnel",
    "Retail, hospitality, and service workers (e.g. cashiers, servers, etc..)": "service_workers"
};

    const [socialActivities, setSocialActivities] = useState(Array(socialActivitiesList.length).fill(-99));
    const [onlineActivities, setOnlineActivities] = useState(Array(onlineActivitiesList.length).fill(-99));
    const [interactionCheckboxes, setInteractionCheckboxes] = useState({});
    const [interactionTime, setInteractionTime] = useState(Array(interactionCheckboxes.length).fill(-99));
    const [otherInteraction, setOtherInteraction] = useState('');
    const [noneSelected, setNoneSelected] = useState(false);
   

    const isInteractionTimeComplete = interactionTime.every(val => val !== -99);
    const isAnyInteractionChecked = Object.values(interactionCheckboxes).some(value => value === true);
    const isOtherInteractionFilled = otherInteraction.trim() !== '';

    const socialInteractionRatings = {};
        socialActivitiesList.forEach((statement, index) => {
            const key = socialActivitiesMap[statement];
            socialInteractionRatings[key] = socialActivities[index];
        });

    const onlineInteractionRatings = {};
        onlineActivitiesList.forEach((statement, index) => {
            const key = onlineActivitiesMap[statement];
            onlineInteractionRatings[key] = onlineActivities[index];
        });

    const generateInteractionTimeRatings = () => {
        const interactionTimeRatings = {};
        let timeIndex = 0;

        Object.keys(interactionCategories).forEach((categoryKey) => {
            const mappedKey = interactionTypesMap[interactionCategories[categoryKey]];

            if (interactionCheckboxes[categoryKey]) {
                interactionTimeRatings[mappedKey] = interactionTime[timeIndex] !== undefined ? interactionTime[timeIndex] : -99;
                timeIndex++;
            } else {
                interactionTimeRatings[mappedKey] = -99;
            }
        });

        if (otherInteraction.trim() !== '') {
            interactionTimeRatings['interaction_type_other'] = interactionTime[timeIndex] !== undefined ? interactionTime[timeIndex] : -99;
        }

        return interactionTimeRatings;
    };
    

    const handleCheckboxChange = (event) => {
    if (event.target.name === 'none') {
        setNoneSelected(event.target.checked);
        setInteractionCheckboxes({});
    } else {
        setNoneSelected(false);
        setInteractionCheckboxes({
            ...interactionCheckboxes,
            [event.target.name]: event.target.checked
        });
    }
};

    const handleOtherChange = (event) => {
        setOtherInteraction(event.target.value);
    };


    const handleNextPage = () => {

    const totalHours = socialActivities.reduce((sum, current) => sum + current, 0);

    if (currentPage === 1) {
        const isSocialActivitiesComplete= socialActivities.every(val => val !== -99);
        if (!isSocialActivitiesComplete) {
            setShowDialog(true);
            return;
        }
        else if (totalHours !== 24) {
            setShowHourDialog(true); // Show dialog if total hours is not 24
            return;
        }
    }
        
    if (currentPage === 2) {
        const isOnlineActivitiesComplete= onlineActivities.every(val => val !== -99);
        if (!isOnlineActivitiesComplete) {
            setShowDialog(true);
            return;
        }
    }

    if (currentPage === 3 && noneSelected) {
        // Skip to submission if "None" is selected
        handleFinalSubmit();
    } 

    setCurrentPage(currentPage + 1);

};

    const handleFinalSubmit = () => {

        if (noneSelected) {
        // Submit data with "None" selected
        const data = {
            socialInteraction: socialInteractionRatings,
            onlineInteraction: onlineInteractionRatings,
            interactionCategories: ['None'],
            interactionTime: {},
            otherInteraction: ''
        };
        nextTask({ data: data });
    } else {
        


        if (!isInteractionTimeComplete) {
            setShowDialog(true);
            return;
        }


        const selectedInteractionCategories = Object.entries(interactionCheckboxes)
        .filter(([key, value]) => value)
        .map(([key]) => interactionCategories[key]);


        const interactionTimeRatings = generateInteractionTimeRatings();


        const data = {
        socialInteraction: socialInteractionRatings,
        onlineInteraction: onlineInteractionRatings,
        interactionCategories: selectedInteractionCategories,
        interactionTime: interactionTimeRatings,
        otherInteraction
    };

        nextTask({ data: data });
    } };



    const interactionRows = Object.keys(interactionCategories)
            .filter(key => interactionCheckboxes[key])
            .map(key => interactionCategories[key])
            .concat(otherInteraction ? [otherInteraction] : []);



    


    return (
        <PageContainer>

        <div>
            {currentPage === 1 && ( <div>
                <Typography gutterBottom>Please report how much time you spent in the last day on the following activities. These activities are listed in order of how much social engagement they involve. Your responses in this section should add up to 24 hours.</Typography>
                
                <div style={{ height: '20px' }}></div> 

                <TimeMatrixQuestion 
                    title=<Typography gutterBottom>In the past 24 hours, how many hours did you spend:</Typography>
                    rows={socialActivitiesList}
                    handleUpdate={(data) => setSocialActivities(data)}
                />

                                            <div style={{ height: '20px' }}></div> 

                </div>
            )}

            {currentPage === 2 && ( <div>
            <Typography gutterBottom>Below, please indicate how many hours you spent on the following activities in the past 24 hours. If you are not sure, please provide your best estimate.</Typography>

                <div style={{ height: '20px' }}></div> 

                <TimeMatrixQuestion 
                    title=<Typography gutterBottom>In the past 24 hours, how many hours did you spend:</Typography>
                    rows={onlineActivitiesList}
                    handleUpdate={(data) => setOnlineActivities(data)}
                />
                                            <div style={{ height: '20px' }}></div> 

                </div>
            )}

            {currentPage === 3 && (
                <FormGroup>
                    <Typography gutterBottom>
                        Consider the people with whom you have interacted in the past week. Which of the following categories describe the people you have interacted with in the past week? Please select all that apply.
                    </Typography>
                    {Object.entries(interactionCategories).map(([key, label]) => (
                        <FormControlLabel
                            key={key}
                            control={<Checkbox checked={interactionCheckboxes[key] || false} onChange={handleCheckboxChange} name={key} />}
                            label={label}
                        />
                    ))}
                    <TextField
                        label="Other"
                        value={otherInteraction}
                        onChange={handleOtherChange}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                    />

                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={noneSelected}
                        onChange={handleCheckboxChange}
                        name="none"
                        disabled={isAnyInteractionChecked || isOtherInteractionFilled}
                        />}
                        label="None"/>

                                                                    <div style={{ height: '20px' }}></div> 



                </FormGroup>
            )}


            {currentPage === 4 && (
            <div>
            <Typography gutterBottom>Please indicate how many hours per day on average you spent interacting with people in each category in the past week.</Typography>
                            
                            <div style={{ height: '20px' }}></div> 


            <Typography gutterBottom>Do not include time you spent merely co-existing or being around people while not interacting; Only count how much time you spent actually interacting.</Typography>
            
                            <div style={{ height: '20px' }}></div> 

            <Typography gutterBottom>Include time spent interacting in person, as well as virtually (e.g. over the phone or online). If you're not sure, please provide your best estimate.</Typography>
                
                                <div style={{ height: '20px' }}></div> 

                <TimeMatrixQuestion 
                    rows={interactionRows}
                    handleUpdate={(data) => setInteractionTime(data)}
                />
                            <div style={{ height: '20px' }}></div> 

                </div>


            )}

            {currentPage === 4 && !noneSelected && (
                <div>
                <Button variant="contained" onClick={handleFinalSubmit} disabled={!isInteractionTimeComplete}>Next</Button>

                    
                </div>
            )}

            {currentPage < 4 && (
                <div>

                <Button variant="contained" onClick={handleNextPage} disabled={currentPage === 3 && !isAnyInteractionChecked && !isOtherInteractionFilled &&!noneSelected}>Next</Button>

                 <CustomConfirmationDialog
                 open={showDialog}
                 onClose={() => setShowDialog(false)}
                 onConfirm={() => {setShowDialog(false);
                setCurrentPage(currentPage + 1);


             }}/>


             <CustomHourDialog
                 open={showHourDialog}
                 onClose={() => setShowHourDialog(false)}
                 onConfirm={() => {setShowHourDialog(false);
             }}/>


                </div>
            )}
        </div>
    </PageContainer>
);
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(SocialInteraction);


